<div [class]="containerClass">
  <!-- Variante de botón normal -->
  <button 
    *ngIf="!isLink && !isIconOnly"
    pButton 
    [icon]="icon"
    [label]="showLabel ? label : ''"
    [class]="buttonClass"
    (click)="goBack()"
    pTooltip="Volver a la página anterior"
    tooltipPosition="bottom">
  </button>

  <!-- Variante solo icono -->
  <button 
    *ngIf="!isLink && isIconOnly"
    pButton 
    [icon]="icon"
    [class]="buttonClass"
    (click)="goBack()"
    pTooltip="Volver a la página anterior"
    tooltipPosition="bottom">
  </button>

  <!-- Variante de enlace -->
  <a 
    *ngIf="isLink"
    href="javascript:void(0)"
    [class]="'back-link ' + buttonClass"
    (click)="goBack()"
    pTooltip="Volver a la página anterior"
    tooltipPosition="bottom">
    <i [class]="icon"></i>
    <span *ngIf="showLabel">{{ label }}</span>
  </a>
</div> 